import { faMobileAlt, faMapMarkedAlt } from '@fortawesome/free-solid-svg-icons';
import { faBuffer } from '@fortawesome/free-brands-svg-icons'

export const usefulLink = [
    { name: 'Home', id: 1 },
    { name: 'Services', id: 3 },
    { name: 'Careers', id: 4 },
    { name: 'Contact', id: 5 }
]
export const ourServices = [
    { name: 'WEB SERVICES', id: 6 },
    { name: 'PENETRATION TESTING', id: 7 },
    { name: 'Managed Security', id: 8 },
]
export const otherLinks = [
    { name: 'FAQ', id: 11 },
    { name: 'Privacy Policy', id: 13 },
    { name: 'Terms & Conditions', id: 14 },
    { name: 'Support', id: 15 },
]

export const footerInfo = [
    { icon: faBuffer, info1: 'AspireHive', id: 1 },
    { icon: faMobileAlt, info1: '+91-6360366247', info2: 'info@aspirehive.com', id: 2 },
    { icon: faMapMarkedAlt, info1: 'Lourd Nagar, Doora, Mysuru 570001', info2: 'Karnataka – India.', id: 3 }
];